import { getGlobalEventMergeIdIfVariationChanged } from '../../_common/client/tracking';
import { BaseComponent } from '../../base-component';
import { addLabels } from '@otto-ec/global-resources/apm';

export class RecoSponsoredComponent extends BaseComponent {
    public static ROOT_SELECTOR = '.js_pdp_reco-sponsored';
    public rootSelector = RecoSponsoredComponent.ROOT_SELECTOR;

    public async onHtmlLoaded(): Promise<void> {
        if (!this.isPresent()) {
            return;
        }

        const variationId = this.getRootElement().dataset.variationId;
        if (!variationId) {
            return;
        }

        const cinemaElement = document.createElement('hopper-auction-cinema-v1');
        cinemaElement.variationId = variationId;
        const eventMergeId = getGlobalEventMergeIdIfVariationChanged();
        if (eventMergeId) {
            cinemaElement.eventMergeId = eventMergeId;
        }
        this.getRootElement().replaceChildren(cinemaElement);

        addLabels({
            ft5_reco_sponsored_is_web_component: true,
        });
    }
}
